// Get value from Cookie
export const getCookieValue = (name: string) => {
  if (typeof window !== 'undefined') {
    const cookieValue = document.cookie.split(';').find(cookie => cookie.trim().startsWith(`${name}=`));
    return cookieValue ? cookieValue.split('=')[1] : null;
  }
};
